import { Dungeon } from '../dungeon/Dungeon';
import { Vec3 } from '../types';
import { shuffle } from '../utils/random';

export interface TurnaroundTrap {
  position: Vec3;
  cellX: number;
  cellZ: number;
  triggered: boolean;
}

export const TURNAROUND_TRIGGER_RADIUS = 0.4;

export function placeTurnaroundTrap(
  dungeon: Dungeon,
  excludeCell: { x: number; z: number },
  excludeRadius: number,
  occupiedCells: Set<string>
): TurnaroundTrap | null {
  const corridorCells: { x: number; z: number }[] = [];
  const fallbackCells: { x: number; z: number }[] = [];

  for (let z = 1; z < dungeon.height - 1; z++) {
    for (let x = 1; x < dungeon.width - 1; x++) {
      if (!dungeon.isWalkable(x, z)) continue;
      if (occupiedCells.has(`${x},${z}`)) continue;

      const dx = x - excludeCell.x;
      const dz = z - excludeCell.z;
      if (Math.sqrt(dx * dx + dz * dz) < excludeRadius) continue;

      // Prefer corridor cells: exactly 2 neighbors on opposite sides
      const n = dungeon.isWalkable(x, z - 1);
      const s = dungeon.isWalkable(x, z + 1);
      const e = dungeon.isWalkable(x + 1, z);
      const w = dungeon.isWalkable(x - 1, z);

      const isCorridor = (n && s && !e && !w) || (!n && !s && e && w);
      if (isCorridor) {
        corridorCells.push({ x, z });
      } else {
        fallbackCells.push({ x, z });
      }
    }
  }

  shuffle(corridorCells);
  shuffle(fallbackCells);
  const candidates = [...corridorCells, ...fallbackCells];
  if (candidates.length === 0) return null;

  const cell = candidates[0];
  const worldPos = dungeon.cellToWorld(cell.x, cell.z);

  return {
    position: { x: worldPos.x, y: 0, z: worldPos.z },
    cellX: cell.x,
    cellZ: cell.z,
    triggered: false
  };
}
